const isDefined = (variable) => {
	return !(typeof variable === 'undefined' || variable === null);
}

export default isDefined;